export const columnsKeys = ['stepNumber', 'title'];

export const defaultTableColumns = {
    stepNumber: 'Шаг, №',
    title: 'Название шага',
};
